import { useState } from "react";
import dayjs from "dayjs";
import classNames from "classnames";
import { Button, Typography } from "components/atoms";
import "./index.scss";
import { MonthNavigator } from "../MonthNavigator";

const daysofTheWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

interface IProps {
  setDay: any;
}

export const CalendarMobile = ({ setDay }: IProps) => {
  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const incrementMonth = () => {
    setCurrentMonth((prevMonth) => prevMonth.add(1, "month"));
  };

  const decrementMonth = () => {
    setCurrentMonth((prevMonth) => prevMonth.subtract(1, "month"));
  };

  const handleMobileDayClick = (clickDay: any) => {
    setDay(clickDay);
  };

  const mobileRenderBody = () => {
    const monthStart = currentMonth.startOf("month");
    const monthEnd = currentMonth.endOf("month");
    const startDate = monthStart.startOf("week");
    const endDate = monthEnd.endOf("week");

    const weeks = [];
    let week = [];

    for (let day = startDate; day.isBefore(endDate); day = day.add(1, "day")) {
      if (day.isSameOrAfter(monthStart) && day.isSameOrBefore(monthEnd)) {
        week.push({
          dateNumber: day,
          inCurrentMonth: true,
        });
      } else {
        week.push({
          dateNumber: day,
          inCurrentMonth: false,
        });
      }
      if (day.day() === 6) {
        weeks.push(week);
        week = [];
      }
    }

    return weeks.map((week, i) => (
      <tr key={i}>
        {week.map((day, j) => (
          <td key={j}>
            <div
              className={classNames({
                "tbody-td-parent-wrapper": true,
                "blur-date-number": day.inCurrentMonth === false,
              })}
            >
              <div
                className="header-date-number-wrapper"
                onClick={() => handleMobileDayClick(day.dateNumber)}
              >
                <Typography
                  variant="h8Med"
                  label={day.dateNumber.format("D")}
                  styles={
                    day.inCurrentMonth === true &&
                    day.dateNumber.format("DD/MM/YYYY") ===
                      dayjs().format("DD/MM/YYYY")
                      ? "today-date-typography-custom-style day-number-custom-style"
                      : "date-typography-custom-style day-number-custom-style"
                  }
                />
              </div>
            </div>
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <>
      <div className="calendar-mobile-nav-wrapper">
        <Button
          icon={false}
          label="Today"
          type="score"
          onClick={() => setCurrentMonth(dayjs())}
        />
        <MonthNavigator
          incrementMonth={incrementMonth}
          decrementMonth={decrementMonth}
          text={currentMonth.format("MMMM YYYY")}
        />
      </div>
      <div className="calendar-mobile-dates-wrapper">
        <table className="study-table-mobile" rules="none">
          <thead>
            <tr>
              {daysofTheWeek.map((weekday, index) => (
                <th key={index}>
                  <Typography
                    variant="h8Med"
                    label={weekday[0]}
                    styles={
                      weekday[0] === "S"
                        ? "day-name-custom-style-gray"
                        : "day-name-custom-style-black"
                    }
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{mobileRenderBody()}</tbody>
        </table>
      </div>
    </>
  );
};
